export default "__VITE_ASSET__9Z5QELCT__"